exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.force-club-activate-success-module-button-label {\n    white-space: nowrap;\n}\n", ""]);

// exports
